"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tableRowWithDigitalHig = exports.defaultProps = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));
var _excluded = ["activated", "className", "enableInteractions", "highlighted", "onClick"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var defaultProps = exports.defaultProps = {
  activated: false,
  enableInteractions: true,
  highlighted: false,
  selected: false
};

/**
 * Makes a Digital HIG table row component using the provided MUITableRow as base
 */
var tableRowWithDigitalHig = exports.tableRowWithDigitalHig = function tableRowWithDigitalHig(BaseMuiTableRow) {
  /**
   * Table row component
   *
   * @param {Object} props
   * @param {string} [props.activated] - Whether to show the row in a activated state
   * @param {string} [props.className] - Class names to apply to the icon component
   * @param {bool} [props.enableInteractions] - Whether to allow row interactions
   * @param {string} [props.highlighted] - Whether to show the row in a highlighted state
   * @param {func} [props.onClick] - `onClick` function, used if interactions are allowed
   * @param {...*} [otherProps] - Additional arguments to pass to table row
   */
  var TableRow = function TableRow(_ref) {
    var activated = _ref.activated,
      className = _ref.className,
      enableInteractions = _ref.enableInteractions,
      highlighted = _ref.highlighted,
      onClick = _ref.onClick,
      otherProps = _objectWithoutProperties(_ref, _excluded);
    // https://mui.com/material-ui/api/table-row/
    // List out complete MUI API props and fillout values for props that will be
    // preset in the component; all the others will be received from the parent
    var muiTableRowApiPresets = {
      // children,
      // classes,
      // component,
      // hover,
      // selected,
      // sx
    };
    var classnames = className && className.split(" ") || [];
    enableInteractions && classnames.push("DhigTableRow--enableInteractions");
    activated && classnames.push("DhigTableRow--activated");
    highlighted && classnames.push("DhigTableRow--highlighted");
    var additionalProps = enableInteractions ? {
      tabIndex: 0,
      role: "button",
      onClick: onClick
    } : {};
    return /*#__PURE__*/_react.default.createElement(BaseMuiTableRow, _extends({}, muiTableRowApiPresets, additionalProps, otherProps, {
      className: classnames.join(" ")
    }));
  };
  TableRow.propTypes = {
    activated: _propTypes.default.bool,
    className: _propTypes.default.string,
    enableInteractions: _propTypes.default.bool,
    highlighted: _propTypes.default.bool,
    onClick: _propTypes.default.func
  };
  TableRow.defaultProps = _objectSpread({}, defaultProps);
  return TableRow;
};
var TableRow = tableRowWithDigitalHig(_TableRow.default);
var _default = exports.default = TableRow;